import { render, staticRenderFns } from "./systemParams.vue?vue&type=template&id=1a7eb4c2&scoped=true"
import script from "./systemParams.vue?vue&type=script&lang=js"
export * from "./systemParams.vue?vue&type=script&lang=js"
import style0 from "./systemParams.vue?vue&type=style&index=0&id=1a7eb4c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7eb4c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a7eb4c2')) {
      api.createRecord('1a7eb4c2', component.options)
    } else {
      api.reload('1a7eb4c2', component.options)
    }
    module.hot.accept("./systemParams.vue?vue&type=template&id=1a7eb4c2&scoped=true", function () {
      api.rerender('1a7eb4c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/compontents/systemParams.vue"
export default component.exports